module.exports = __webpack_public_path__ + "static/media/3-2.9f4e798a.webp";